module.exports = __webpack_public_path__ + "img/snow_fall_00019.e6623ff2.png";